import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '__services';
import { isEmpty } from 'lodash';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ComplianceConst } from '~/app/containers/dashboard/compliance/constants/compliance.const';
import { Constants } from '~/app/core/configs/constants';
import { CommonService } from '~/app/core/services/common.service';
import { Type } from '../../../../containers/dashboard/admin/constants/admin.const';

@Component({
  selector: 'app-admin-filter',
  templateUrl: './admin-filter.component.html',
  styleUrls: ['./admin-filter.component.scss']
})
export class AdminFilterComponent implements OnInit {
  @Input() filterConfig;
  @Output() valueChange = new EventEmitter();

  form: FormGroup;
  isReset = false;
  countries: any[] = [];
  personas: any[] = [];
  licenceList: any[] = [
    {
      id: 1,
      name: 'Free',
    },
    {
      id: 2,
      name: 'Subscription',
    },
    {
      id: 3,
      name: 'Referred',
    },
  ];
  defaultParams = {
    offset: 0,
    limit: Constants.DefaultLimit,
    sort: `${Constants.SortBy.name} ${Constants.OrderBy.asc}`,
  };
  filteredParams = {
    ...this.defaultParams,
    country: null,
    persona: null,
    q: null,
  };
  type = Type;
  addPermission;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private roleService: RoleService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.addPermission = this.roleService.hasAdd(this.route.snapshot);
    console.log(JSON.stringify(this.filterConfig));

    if(this.filterConfig && this.filterConfig.defaultParams) {
      this.filteredParams = {...this.filteredParams, ...this.filterConfig.defaultParams}
      this.defaultParams = {...this.defaultParams, ...this.filterConfig.defaultParams}
    }
    this.form = this.fb.group({
      status: [null],
      country: [null],
      company_id: [null],
      persona: [null],
      role_id: [null],
      collar_type: [null],
      user_id: [null],
      search: [null],
      licence_type: [null]
    });

    this.commonService.countries
      .pipe(take(1))
      .subscribe((res) => (this.countries = res.data));
    this.commonService.personas
      .pipe(take(1))
      .subscribe((res) => {this.personas = res.data
        console.log(this.personas);

      });
    this.onReload();
  }

  onValueChanged($event: any): void {
    this.setParams();
  }

  setParams(): void {
    const {
      status,
      company_id,
      role_id,
      collar_type,
      persona,
      country,
      search,
      user_id,
      licence_type
    } = this.form.value;
    let query: any = {
      status,
      company_id,
      role_id,
      collar_type,
      licence_type
    };
    this.filteredParams.persona = persona;
    this.filteredParams.country = country;
    this.filteredParams.q = search;
    if (this.filterConfig.type === ComplianceConst.Flows && query.status === null)  {
      query.status = { inq: this.filterConfig.defaultStatus }
    }
    if (this.filterConfig.type === Type.party) {
      query = { ...query, persona_id: persona, country_id: country };
      this.filteredParams.persona = null;
    }
    if(user_id && this.filterConfig.type === Type.category) {
      query = { ...query, granted_users: { contains: [user_id]} };
    }
    this.valueChange.emit(
      this.removeEmpty({
        ...this.filteredParams,
        where: this.removeEmpty(query),
      })
    );
  }

  onSearch(): void {
    this.setParams();
  }

  onReload(): void {
    if (this.form) {
      this.form.reset();
    }

    if (this.filterConfig.type === ComplianceConst.Flows) {
      this.valueChange.emit(this.removeEmpty({
        ...this.defaultParams,
        where: { status: { inq: this.filterConfig.defaultStatus } },
      }));
    } else {
      this.valueChange.emit(this.removeEmpty(this.defaultParams));
    }
  }

  removeEmpty(obj: any): any {
    Object.entries(obj).forEach(([key, val]) => {
      if (val && typeof val === 'object' && key != 'inq') {
        this.removeEmpty(val);
      } else if ((!val && !['status', 'collar_type'].includes(key)) || (key == 'status' && val == null) || (key == 'collar_type' && val == null)) {
        delete obj[key];
      }
    });
    return isEmpty(obj) ? null : obj;
  }

  navigateToAddPage(): void {
    if(this.filterConfig.buttonDisabled) return;
    this.router.navigate([
      (this.filterConfig.type === ComplianceConst.Flows ? '/compliance/' : this.filterConfig.roleLogChainAdmin ? '/logchain-admin/' : '/admin/') +
        this.filterConfig.addRouterLink,
    ]);
  }
}
